export default __webpack_public_path__ + "static/home-cover-3-fa8900515382d417bbc34de1b6bad879.jpeg";